import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  LayoutDashboard,
  Users,
  ClipboardList,
  Dumbbell,
  Calendar,
  Settings,
  Sparkles,
  TrendingUp,
} from 'lucide-react';
import { cn } from '@/lib/cn';

interface NavItem {
  to: string;
  labelKey: string;
  icon: typeof LayoutDashboard;
}

const TRAINER_NAV: NavItem[] = [
  { to: '/trainer', labelKey: 'nav.dashboard', icon: LayoutDashboard },
  { to: '/trainer/clients', labelKey: 'nav.clients', icon: Users },
  { to: '/trainer/plans', labelKey: 'nav.plans', icon: ClipboardList },
  { to: '/trainer/exercises', labelKey: 'nav.exercises', icon: Dumbbell },
  { to: '/trainer/calendar', labelKey: 'nav.calendar', icon: Calendar },
  { to: '/trainer/assistant', labelKey: 'nav.assistant', icon: Sparkles },
  { to: '/trainer/settings', labelKey: 'nav.settings', icon: Settings },
];

const CLIENT_NAV: NavItem[] = [
  { to: '/client', labelKey: 'nav.my_plans', icon: ClipboardList },
  { to: '/client/workouts', labelKey: 'nav.my_workouts', icon: Dumbbell },
  { to: '/client/progress', labelKey: 'nav.progress', icon: TrendingUp },
  { to: '/client/profile', labelKey: 'nav.profile', icon: Settings },
];

export function Sidebar({ role }: { role: 'trainer' | 'client' }) {
  const { t } = useTranslation('common');
  const items = role === 'trainer' ? TRAINER_NAV : CLIENT_NAV;

  return (
    <aside className="hidden w-60 shrink-0 border-r border-border bg-card/30 md:flex md:flex-col">
      <nav className="flex flex-col gap-1 p-3">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to.split('/').length === 2}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                  isActive
                    ? 'bg-accent text-accent-foreground font-medium'
                    : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground',
                )
              }
            >
              <Icon className="h-4 w-4" />
              <span>{t(item.labelKey)}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
